/**
 * @file AGL 服务到期提醒弹窗
 * @link https://tickets.umu.work/browse/AI-2919
 */

import Api from '../../../path';
import { fetchData } from '@umu/umu-fetch';

export type AglExpiryReminderPopupType = 90 | 60 | 30 | 15 | 7 | 3 | 1 | 0;

export interface IGetAglExpiryReminderPopupOutput {
    should_popup: boolean;
    popup_type: AglExpiryReminderPopupType | null;
    end_date: number;
    end_date_str: string;
}

/**
 * 查询当前企业管理员今天是否需要弹出 AGL 服务到期提醒
 */
export const getAglExpiryReminderPopup = (): Promise<IGetAglExpiryReminderPopupOutput> => {
    return fetchData(Api.AGL_EXPIRY_REMINDER_POPUP, {}, { silent: true }).then(
        (res: IResponse<IGetAglExpiryReminderPopupOutput>) => {
            return res.data as IGetAglExpiryReminderPopupOutput;
        },
    );
};

export interface IMarkAglExpiryReminderPopupShownOutput {
    marked: boolean;
}

/**
 * 标记今天已展示过 AGL 服务到期提醒弹窗，需等弹窗真正渲染出来后才可调用
 */
export const markAglExpiryReminderPopupShown = (): Promise<IMarkAglExpiryReminderPopupShownOutput> => {
    return fetchData(Api.AGL_EXPIRY_REMINDER_POPUP_SHOWN, {}).then(
        (res: IResponse<IMarkAglExpiryReminderPopupShownOutput>) => {
            return res.data as IMarkAglExpiryReminderPopupShownOutput;
        },
    );
};
